import MessageBox from './MessageBox';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';

const RegistrationFail = () => (
  <MessageBox
    header="Whoops!"
    message="Your account registration has failed."
    secondaryMessage={SUPPORT_MESSAGE}
  />
);

export default RegistrationFail;
